import { ClassAttributes } from 'react';
import _NonFatalErrorSnackbars from '../component/compound/NonFatalErrorSnackbars';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';
//import { useReactiveVar } from '@apollo/client';
//import { errorsVar } from '../../cache';
//import globalState from '../../operations/commands';
//import { FatalError } from '../../operations/commands/Errors/setErrors';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const NonFatalErrorSnackbars = ({ className }: Props) => {
  //const errors = useReactiveVar(errorsVar)?.filter(e => !(e instanceof FatalError));
  return (
    <DependencyConsumer>
      {(dependency) => (
        <StateConsumer>
          {(state) => (
            <_NonFatalErrorSnackbars
              errors={state.nonFatalErrors /*?? errors*/}
              onRequestClose={(_: any, err: Error) => {
                dependency.errorPresenter.removeNonFatal(err);
                //!state.nonFatalErrors && errors && globalState.disposeErrors()
              }}
              className={className}
            />
          )}
        </StateConsumer>
      )}
    </DependencyConsumer>
  );
};

export default NonFatalErrorSnackbars;
